export default "__VITE_ASSET__9ee88f16__"